/***** ALERT  ***/
$(document).ready(function () {

	const cookieBase = 'alert-dismissed';
	const days = 20;

	function setCookie(name, value, days) {
		const d = new Date();
		d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = "expires=" + d.toUTCString();
		document.cookie = name + "=" + value + ";" + expires + ";path=/";
	}

	function getCookie(name) {
		const cname = name + "=";
		const decoded = decodeURIComponent(document.cookie);
		const ca = decoded.split(';');

		for (let i = 0; i < ca.length; i++) {
			let c = ca[i].trim();
			if (c.indexOf(cname) === 0) {
				return c.substring(cname.length, c.length);
			}
		}
		return "";
	}

	/* --- 1) Masquer les alertes déjà fermées individuellement --- */
	$('.module-alert').each(function () {
		const dkey = $(this).data('key');
		if (!dkey) return;

		const cookieName = `${cookieBase}-${dkey}`;
		if (getCookie(cookieName) === "1") {
			$(this).remove();
		}
	});

	/* --- 2) Si au moins une alerte visible → ajuster header --- */
	if ($('.module-alert').length > 0) {
		$('.module-alert').removeClass("hide");
		$('.partials-header-default').addClass("has-alert");
		$('.partials-header-news').addClass("has-alert");
		$('.partials-header-single').addClass("has-alert");
	}

	/* --- 3) Fermeture individuelle d’une alerte --- */
	$('.close-alert').on('click', function () {
		const $alert = $(this).closest('.module-alert');
		const dkey = $alert.data('key');

		$alert.fadeOut(500, function () {
			$alert.remove();

			// Si plus aucune alerte visible
			if ($('.module-alert').length < 1) {
				$('.partials-header-default').removeClass("has-alert");
				$('.partials-header-news').removeClass("has-alert");
				$('.partials-header-single').removeClass("has-alert");
			}

			// Enregistrer cookie individuel
			if (dkey) {
				const cookieName = `${cookieBase}-${dkey}`;
				setCookie(cookieName, "1", days);
			}
		});
	});

});
